module.exports = __webpack_public_path__ + "static/media/received.f113eaf8.svg";